// app/javascript/controllers/toggle_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["select", "toggle"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedValue = this.selectTarget.value

    this.toggleTargets.forEach((target) => {
      const values = (target.dataset.toggleValues || "").split(",").map(v => v.trim())
      const shouldShow = values.includes(selectedValue)

      target.classList.toggle("d-none", !shouldShow)
    })
  }

  change() {
    this.toggleFields()
  }
}